import { useState, useEffect } from 'react';
import logo from '../assets/images/logo.jpeg';

const LINKS = [
  { id: 'home',     label: 'Home' },
  { id: 'about',    label: 'About Us' },
  { id: 'products', label: 'Products' },
  { id: 'delivery', label: 'Delivery Process' },
  { id: 'contact',  label: 'Contact Us' },
];

export default function Navbar({ page, setPage }) {
  const [scrolled, setScrolled]     = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const go = (id) => { setPage(id); setMobileOpen(false); window.scrollTo(0, 0); };

  return (
    <>
      <nav className={`main-nav${scrolled ? ' scrolled' : ''}`}>
        <div className="nav-inner">
          {/* Logo */}
          <button className="nav-logo" onClick={() => go('home')}>
            <img
              src={logo}
              alt="SLN E SHOP TRADERS Logo"
              style={{ height: 70, width: 'auto', objectFit: 'contain' }}
            />
            <div>
              <div className="nav-logo-text">SLN <span>E SHOP</span></div>
              <div className="nav-logo-sub">TRADERS</div>
            </div>
          </button>

          {/* Desktop links */}
          <div className="nav-links">
            {LINKS.map((l) => (
              <button key={l.id} className={`nav-link${page === l.id ? ' active' : ''}`} onClick={() => go(l.id)}>
                {l.label}
              </button>
            ))}
            <button className="btn-primary" style={{ padding: '10px 22px', fontSize: '.84rem' }} onClick={() => go('contact')}>
              Order Now →
            </button>
          </div>

          {/* Hamburger */}
          <button className="hamburger" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? '✕' : '☰'}
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="mobile-menu">
          <img src="/logo.png" alt="SLN E SHOP TRADERS" style={{ height: 56, marginBottom: 8 }} />
          {LINKS.map((l) => (
            <button key={l.id} className={`mobile-link${page === l.id ? ' active' : ''}`} onClick={() => go(l.id)}>
              {l.label}
            </button>
          ))}
          <button className="btn-primary" style={{ marginTop: 8 }} onClick={() => go('contact')}>
            Order Now →
          </button>
        </div>
      )}
    </>
  );
}
